import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import SearchBox from '@adsk/bim360-matrix-react-search-box';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';

const VALIDATOR_TOOLTIP = {color: 'red'};
const INITIAL_STATE = {
  searchExpression: '',
  validationText: '',
  isSearched: false
};

const SearchBoxWithValidatorWrapper = props => {
  const [state, setState] = useState(INITIAL_STATE);

  useEffect(
    () =>
      setState(prevState => ({
        ...prevState,
        searchExpression: props.searchExpression ? props.searchExpression : ''
      })),
    [props.searchExpression]
  );

  const onClear = () => {
    state.isSearched && props.onClear();
    setState(INITIAL_STATE);
  };

  const onSearch = () => {
    props.onSearch(state.searchExpression);
    setState(prevState => ({
      ...prevState,
      isSearched: true
    }));
  };

  const onChange = searchExpressionValue => {
    const text = (searchExpressionValue && props.validate(searchExpressionValue)) || '';
    setState(prevState => ({
      ...prevState,
      validationText: text,
      searchExpression: searchExpressionValue
    }));
  };

  return (
    <Tooltip content={state.validationText} style={VALIDATOR_TOOLTIP}>
      <SearchBox
        {...props}
        searchExpression={state.searchExpression}
        onChange={onChange}
        onSearch={() => !state.validationText && onSearch()}
        onClear={onClear}
        inputProps={{
          // Necessary because of a bug in the SearchBox component
          onKeyUp: e => e.key === 'Enter' && !state.validationText && onSearch()
        }}
      />
    </Tooltip>
  );
};

SearchBoxWithValidatorWrapper.displayName = 'SearchBoxWithValidatorWrapper';
SearchBoxWithValidatorWrapper.propTypes = {
  searchExpression: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired
};

export default SearchBoxWithValidatorWrapper;
